import isSubscriptionsPageActive from 'src/helpers/isSubscriptionsPageActive';

export { default } from 'src';

// You can enable the Skeleton Loader implementation by exporting default from root.loader instead of root.component
// export { default } from './root.loader';

export const mfeInterface = {
  v1: {
    isSubscriptionsPageActive
  }
};
